import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalObservableService implements OnDestroy {
  private subject = new Subject<any>();

  publish(type: string, data?: any) {
    this.subject.next({ type, data });
  }

  getObservable(): Subject<any> {
    return this.subject;
  }

  ngOnDestroy(): void {
    this.subject.complete(); // Evita fugas de memoria
  }
}
